export default defineNuxtRouteMiddleware((to, from) => {
  const organizationStore = useOrganizationStore();

  if (to.params.organization && organizationStore.organizationUrl) {
    const currentOrganization = to.params.organization as string;

    if (organizationStore.organizationUrl != currentOrganization) {
      return `/${organizationStore.organizationUrl}`;
    }
  }
});
